'use client';

import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import type { ReactNode } from 'react';

import { Icon } from '../Spinner/Icon';

const icon = <Icon icon={faEnvelope} aria-label="Email" />;

export function EmailIcon(): ReactNode {
	return icon;
}
